// src/components/Reports/Summaries/PerformanceSummary.js
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const PerformanceSummary = ({ summary }) => {
    // Kontrola, zda summary existuje
    if (!summary) {
        return <p>Není k dispozici shrnutí výkonu.</p>;
    }

    // Bezpečné hodnoty pro případ, že nejsou k dispozici
    const bestWebsite = summary.bestWebsite || { name: 'Nedostupné', score: 0 };
    const worstWebsite = summary.worstWebsite || { name: 'Nedostupné', score: 0 };

    return (
        <Row>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Průměrné skóre</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.averageScore || 0}/100</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Nejlepší web</h6>
                    <div className="fs-4 fw-bold text-primary">{bestWebsite.name}</div>
                    <div className="text-muted small">{bestWebsite.score}/100</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Nejhorší web</h6>
                    <div className="fs-4 fw-bold text-primary">{worstWebsite.name}</div>
                    <div className="text-muted small">{worstWebsite.score}/100</div>
                </div>
            </Col>
            <Col lg={3} md={6} className="mb-3">
                <div className="p-3 bg-light rounded text-center">
                    <h6 className="text-muted mb-2">Průměrný TTFB</h6>
                    <div className="fs-3 fw-bold text-primary">{summary.averageTTFB || 'N/A'}</div>
                </div>
            </Col>
        </Row>
    );
};

export default PerformanceSummary;